import React from 'react';
import Skeleton from 'react-loading-skeleton';

import 'react-loading-skeleton/dist/skeleton.css';
import styles from './CompanyProfileHeaderLoader.module.scss';

const CompanyProfileHeaderLoader = () => (
  <div className={`${styles.container} d-flex flex-column`}>
    <div className={styles.bgImageDiv}>
      <Skeleton height={200} />
    </div>

    <div className={styles.profileImageDiv}>
      <Skeleton height={50} />
    </div>

    <div className={styles.userInfo}>
      <div className={styles.primaryContent}>
        <Skeleton borderRadius={6} height={8} />
      </div>
      <div className={styles.secondaryContent}>
        <Skeleton borderRadius={6} height={8} />
      </div>
    </div>

    <div className={styles.buttons}>
      <div className={styles.primaryButton}>
        <Skeleton borderRadius={6} height={36} />
      </div>
      <div className={styles.secondaryButton}>
        <Skeleton borderRadius={6} height={36} />
      </div>
      <div className={styles.secondaryButton}>
        <Skeleton borderRadius={6} height={36} />
      </div>
    </div>
  </div>
);

export default CompanyProfileHeaderLoader;
